export class MessageModel {
  public id: number;
  public alias: string;
  public fechaDesde: Date;
  public imagen: string;
  public mensaje: string;
  public titulo: string;

  constructor() {
    this.id = 0;
    this.alias = '';
    this.fechaDesde = new Date();
    this.imagen = '';
    this.mensaje = '';
    this.titulo = '';
  }
}
